// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"24f33f41","137":"cd9fbe83","286":"3e257f9f","324":"8c465183","363":"f17d0106","564":"6667a8b9","591":"d81b77ac","638":"d7a59a4d","889":"b68b06ff","929":"22327fb6"}[chunkId] + ".chunk.js";
};